import { getAuthPortalAccountUrl, getAuthPortalLoginUrl } from './authPortal';
import {
  clearStaleInsightSessionMarkers,
  consumeAuthPortalAccountVisit,
  markAuthPortalAccountVisit,
} from './authPortalAccountVisit';
import { isAuthPortalSessionAlive, isAuthPortalSessionAliveWithRecheck } from './authPortalSession';

/**
 * Decide where a user-profile trampoline should send the browser.
 * @returns {'login' | 'account'}
 */
export async function resolveAuthPortalAccountRedirectTarget({
  fetchImpl = fetch,
  storage = sessionStorage,
  clearStaleMarkers = clearStaleInsightSessionMarkers,
} = {}) {
  // Returning from a prior OC /account hop: only force MUI login when OC is gone.
  // Cancel / back with a live session must not kick the user out.
  if (consumeAuthPortalAccountVisit(storage)) {
    const ocAlive = await isAuthPortalSessionAlive(fetchImpl);
    if (!ocAlive) {
      clearStaleMarkers();
      return 'login';
    }
    markAuthPortalAccountVisit(storage);
    return 'account';
  }

  // First hop to OC /account: require a stable live session (double probe)
  // so a mid-teardown auth/me 200 does not send users to Classic /account.
  const ocAlive = await isAuthPortalSessionAliveWithRecheck(fetchImpl);
  if (!ocAlive) {
    clearStaleMarkers();
    return 'login';
  }

  markAuthPortalAccountVisit(storage);
  return 'account';
}

export function getAuthPortalRedirectUrlForTarget(target) {
  return target === 'account' ? getAuthPortalAccountUrl() : getAuthPortalLoginUrl();
}
